<template>
    <div class="row labelContainer">
        <div class="col-md-3 col-xs-4 ">
            <strong>Period Required</strong>
        </div>
        <div class="col-md-9 col-xs-8 ">

            <select  v-model="selected" @change="updateInquiryPeriod"  class="select_field form-control trading-name-tom-selector" id="changeInquiryPeriod"   name="required_type">
                <option v-for=" (period , index) of inquiryPeriods"
                        :value="period.id">{{ period.required_type }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import TomSelect from 'tom-select'
import {getBookingStatuses} from '@/modules/common/api'
import axios from "axios";

export default {
    name: "selectInquiryPeriod",
    props: {
        inquiryPeriods: {
        },
        inquiryCurrentPeriod:'',
        inquiryId:0,
        viewPage:false
    },
    data() {
        return {
            select: null,
            selected: this.inquiryCurrentPeriod.id,
            oldSelected: this.inquiryCurrentPeriod.id,
        }
    },
    mounted() {
        let vm = this;

    },
    methods: {
        updateInquiryPeriod() {
            if(this.viewPage){
                let period = document.getElementById('changeInquiryPeriod');
                let url = `/webservice/update-inquiry-period/${this.inquiryId}/${period.value}`;

                axios.get(url).then(response => {
                    if(response.data.success){
                        $.notify(response.data.message , 'success');
                        this.selected = period.value;
                        this.oldSelected = period.value;
                    }else{
                        this.selected = this.oldSelected;
                        $.notify(response.data.message , 'error');
                    }
                });
            }

        }
    },
    computed:{
        selectedColor(){
            let colorObj = this.inquiryStatuses.filter(status => status.name == this.selected )[0];
            return 'background-color:'+colorObj.color;
        }
    }
}
</script>
<style scoped>

.octopus-booking-status{
    padding-top: 15px;
    display: flex;
    align-items: center;
}

.status-tom-selector{
    font-size: 16px;
}
#changeInquiryPeriod{
    /*padding-left: 10% !important;*/
    /*width: 35%;*/
    color: #000 !important;
    font-weight: lighter;
    padding-left: 2% !important;
}

@media (max-width: 767px) {
    #changeInquiryPeriod{
        width: 100%;
    }
}
</style>